import {useMatchChain, useMatchWalletAssetList, useMatchWalletAssets, useModal} from "hooks";
import AlphaAvatar from "../AlphaAvatar";
import {NumberFormatter} from "../../utils";
import {WalletAssetMergeType} from "../../types";
import {Radio} from "../../ui";
import {useState} from "react";
import {Button} from "../index";
import TokenSend from "../TokenSend";
import {FormattedMessage} from "react-intl";
import {useDownMd} from "../../hooks/useLayout";

export default function TokenSendList({close}: {
    close: () => void
}) {
    const isDownMd = useDownMd();
    const walletAssets = useMatchWalletAssets()
    const matchWalletAssetList = useMatchWalletAssetList({
        list: walletAssets.mergedAssets
    })
    const {list} = useMatchChain()
    const [checked, setChecked] = useState<WalletAssetMergeType | null>()
    const modal = useModal()
    const onNext = () => {
        checked && modal.show((props) => {
            return <TokenSend onClose={() => {
                props.close()
                close()
            }} onBack={props.close} zIndex={props.zIndex} token={checked}/>
        })
    }
    return (
        <div className={"matchid-token-send-list-box"}>
            <div className={"matchid-token-send-list"}>
                {
                    matchWalletAssetList.list.map((n, index) => {
                        const chain = list?.find((m) => m.id.toString() === n.chain_id)
                        return <div
                            className={`matchid-token-send-item ${checked?.address == n.address ? "matchid-token-send-chekced" : ""}`}
                            onClick={() => {
                                setChecked(n)
                            }} key={index}>
                            <Radio checked={checked?.address == n.address} size={isDownMd ? 18 : 24}/>
                            <div className={"matchid-token-send-content"}>
                                <div className={"matchid-token-send-logo"}>
                                    {n.icon ? <img src={n.icon} alt={n.symbol} className={`matchid-token-send-icon`}/> :
                                        <AlphaAvatar className={`matchid-token-send-icon`} size={isDownMd ? 28 :40}
                                                     name={n.symbol || n.name || ''}/>}
                                    {chain?.iconUrl &&
                                        <img src={chain.iconUrl} alt={chain.name}
                                             className={`matchid-token-send-chain`}/>}
                                </div>
                                <div className={`matchid-token-send-info`}>
                                    <div className={`matchid-token-send-name`}>{n.symbol}</div>

                                    <div className={`matchid-token-send-balance`}>
                                        <NumberFormatter value={n.balance} tFixNum={3}/>
                                    </div>

                                </div>
                            </div>
                        </div>
                    })
                }
            </div>
            <Button size={"lg"} highlight block disabled={!checked} onClick={onNext}><FormattedMessage id={"next"}/></Button>
        </div>
    )
}